import axios from '../../../axios';
import IComposableDashboardCollection from '../types/IComposableDashboardCollection';
import IPinnedDashboardCollection from '../types/IPinnedDashboardCollection';

const url = 'wsreporting/api/';

export const pinDashboardCollection = (
  dashboardCollectionId: string,
  payload: IPinnedDashboardCollection
) => axios.post(`${url}pin-dashboard-collection/${dashboardCollectionId}`, payload);

export const unPinDashboardCollection = (pinnedDashboardCollectionId: string) =>
  axios.delete(`${url}pin-dashboard-collection/${pinnedDashboardCollectionId}`);

export const getMyPinnedDashboardsCollection = () =>
  axios.get(`${url}my-pinned-dashboards-collections`);

export const getPinnedDashboardsCollectionCreatedByCurrentUser = () =>
  axios.get(`${url}all-pinned-dashboards-collections`);

export const assignDashboardCollection = (dashboardCollection: IComposableDashboardCollection) =>
  axios.post(`${url}assign-dashboard-collection`, dashboardCollection);

export const unAssignDashboardCollection = (dashboardCollectionId: string) =>
  axios.delete(`${url}assign-dashboard-collection/${dashboardCollectionId}`);
